import { useField } from "formik";
import { useCallback, useState } from "react";
import { useFieldError, useUpdateEffect } from "@/hooks";
import { Input } from "@/components/ui/Input";
import { ValidationMessage } from "../ValidationMessage";

const FormInput = (props) => {
  const {
    name,
    handleInputChange,
    maxLength,
    type,
    onBlur: handleInputBlur,
    ...rest
  } = props;

  const [, meta, helpers] = useField(name);
  const hasError = useFieldError(name);

  const [currentValue, setCurrentValue] = useState(
    meta.value || meta.initialValue
  );

  useUpdateEffect(() => {
    setCurrentValue(meta.value);
  }, [meta.value]);

  const handleChange = useCallback(
    (event) => {
      let value = event.target.value;

      if (type === "number") {
        value = event.target.value === "" ? "" : Number(event.target.value);
      }

      if (maxLength !== undefined && value.toString().length > maxLength) {
        return;
      }

      setCurrentValue(value);
      helpers.setValue(value);
      helpers.setError("");

      if (handleInputChange) {
        handleInputChange(value);
      }
    },
    [helpers, handleInputChange, maxLength, type]
  );

  const handleBlur = useCallback(
    (event) => {
      // Handle internal Formik blur
      helpers.setTouched(true);

      // Handle custom blur if provided
      if (handleInputBlur) {
        handleInputBlur(event);
      }
    },
    [helpers, handleInputBlur]
  );

  return (
    <div className="flex flex-col">
      <Input
        {...rest}
        type={type}
        value={currentValue}
        hasError={hasError}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <ValidationMessage name={name} />
    </div>
  );
};

export { FormInput };
